module.exports = __webpack_public_path__ + "img/seguro-suficiente.1d75b145.png";